import React from "react";
import MDBox from "../../components/MDBox";
import MDButton from "../../components/MDButton";
import Card from "@mui/material/Card";
import { editAdvertisement, deleteAdvertisement } from "../../assets/firebaseFirestore";
import { useNavigate } from "react-router-dom";
import Icon from "@mui/material/Icon";

const DeleteModal = ({ modal, setModal, getAdvertisements }) => {

  const navigate = useNavigate();
  const switchStatus = () => {
    editAdvertisement({ ...modal, active: !modal?.active }, navigate).then(() => {
      setModal(null);
      getAdvertisements();
    });
  };

  const deleteAd = async () => {
    await deleteAdvertisement(modal?.id);
    await setModal(null);
    await getAdvertisements();
  };

  return (
    <div style={{
      width: "100vw",
      height: "100vh",
      display: "flex",
      position: "fixed",
      left: 0,
      top: 0,
      zIndex: "9999",
      alignItems: "center",
      justifyContent: "center",
    }} className="ModalLAyout">
      <div onClick={() => setModal(null)} style={{
        width: "100vw",
        height: "100vh",
        background: "#00000080",
        left: 0,
        top: 0,
        position: "absolute",
      }} className="ModalBlur"></div>
      <Card style={{
        textAlign: "center",
        padding: "1rem",
        display: "flex",
        gap: "15px",
        flexDirection: "column",
      }} className="modal-wrapper">
        <h3>{modal?.type === "delete" ? "Delete" : modal?.active ? "Deactivate" : "Activate"} Ad?</h3>
        <MDBox sx={{ display: "flex", gap: "15px" }}>
          <MDButton onClick={() => {
            modal?.type === "delete" ? deleteAd() : switchStatus();
          }} variant={"contained"} color={"primary"}>
            <span>Confirm</span>
            <Icon sx={{ marginLeft: "5px" }}>check</Icon>
          </MDButton>
          <MDButton onClick={() => setModal(null)} variant={"contained"} color={"primary"}>
            <span>Cancel</span>
            <Icon sx={{ marginLeft: "5px" }}>cancel</Icon>
          </MDButton>
        </MDBox>
      </Card>
    </div>
  );
};

export default DeleteModal;
